// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".SPBWrapper {\n  margin-top: 40px;\n}\n@media screen and (max-width: 1350px) {\n  .SPBWrapper {\n    margin-top: 28px;\n  }\n}", ""]);
// Exports
module.exports = exports;
